import { switchClasses as i } from "@mui/material";
const r = {
  styleOverrides: {
    root: ({ theme: t }) => ({
      overflow: "visible",
      padding: 0,
      margin: t.spacing(1)
    }),
    switchBase: ({ theme: t }) => ({
      transitionDuration: "300ms",
      "&:hover": {
        borderRadius: "50%",
        backgroundColor: t.palette.action.hover
      },
      "&.Mui-checked": {
        color: t.palette.common.white,
        "& + .MuiSwitch-track": {
          backgroundColor: t.palette.success.main,
          opacity: 1,
          border: 0
        },
        "&:hover": {
          borderRadius: "50%",
          backgroundColor: t.palette.action.hover
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: 0.5
        }
      },
      "&.Mui-focusVisible .MuiSwitch-thumb": {
        border: `6px solid ${t.palette.common.white}`
      },
      "&.Mui-disabled .MuiSwitch-thumb": {
        color: t.palette.mode === "light" ? t.palette.grey[100] : t.palette.grey[600]
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: t.palette.mode === "light" ? 0.7 : 0.3
      }
    }),
    thumb: ({ theme: t }) => ({
      background: t.palette.grey[50],
      boxSizing: "border-box"
    }),
    track: ({ theme: t }) => ({
      backgroundColor: t.palette.grey[500],
      opacity: 1,
      transition: t.transitions.create(["background-color"], {
        duration: 500
      })
    })
  },
  variants: [
    {
      props: {
        size: "small"
      },
      style: {
        [`&.${i.root}`]: {
          width: 34,
          height: 18
        },
        [`.${i.switchBase}`]: {
          top: "-4px",
          left: "-4px",
          margin: 1,
          "&.Mui-checked": {
            transform: "translateX(16px)"
          }
        },
        [`.${i.thumb}`]: {
          width: 16,
          height: 16
        },
        [`.${i.track}`]: {
          borderRadius: 9
        }
      }
    },
    {
      props: {
        size: "medium"
      },
      style: {
        [`&.${i.root}`]: {
          width: 42,
          height: 22
        },
        [`.${i.switchBase}`]: {
          top: "-9px",
          left: "-9px",
          margin: 2,
          "&.Mui-checked": {
            transform: "translateX(20px)"
          }
        },
        [`.${i.thumb}`]: {
          width: 18,
          height: 18
        },
        [`.${i.track}`]: {
          borderRadius: 11
        }
      }
    }
  ]
};
export {
  r as customSwitch
};
//# sourceMappingURL=switch.mjs.map
